import React, { useEffect } from "react";
import { Landing } from "./pages/Landing";
const PAGE_TITLE = "Team Communication Ready - Volume 1";
const PAGE_DESCRIPTION = "Five planned 30-minute team communication workshops with facilitator scripts, role cards and five bonus PDFs. Volume 1. $27 USD, one time.";
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    document.documentElement.lang = "en-US";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <Landing data-id="element-0" data-mp="2wk9zanmsgt0o" />;
}